import { getPortalPeople } from "@/services/PeopleService";

export const fetchPortalPeople = async ({ commit }) => {
  const people = await getPortalPeople();

  commit("setPeople", people);
};
